import React, { useState } from 'react';
import { FaQrcode, FaRupeeSign, FaBuilding, FaPhone, FaEnvelope, FaMapMarkerAlt, FaGlobe, FaDownload, FaCopy } from 'react-icons/fa';

const DonationPage = () => {
  const [copied, setCopied] = useState({
    accountName: false,
    accountNumber: false,
    ifscCode: false,
    accountType: false,
    upiId: false
  });

  const bankDetails = {
    accountName: "Vikash Kumar",
    accountNumber: "59186600000000",
    ifscCode: "HDFC0004815",
    accountType: "SAVING ACCOUNT",
    upiId: "sushilnamberdar000-1@okhdfcbank"
  };

  const upiDetails = {
    upiId: bankDetails.upiId,
    qrCode: `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=upi://pay?pa=${bankDetails.upiId}&pn=VALARCCI%20FOUNDATION&cu=INR`
  };

  const copyToClipboard = (text, field) => {
    navigator.clipboard.writeText(text);
    setCopied(prev => ({ ...prev, [field]: true }));
    setTimeout(() => {
      setCopied(prev => ({ ...prev, [field]: false }));
    }, 2000);
  };

  const downloadQRCode = async () => {
    try {
      const response = await fetch(upiDetails.qrCode);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'valarcci-upi-qr.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading QR code:', error);
    }
  };

  return (
    <div className="min-h-screen py-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-[#eecda3] to-[#6dd5ed]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-black mb-4">Support Our Cause</h1>
          <p className="text-xl text-black">Your donation can make a real difference in someone's life</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Left Column - Donation Methods */}
          <div className="space-y-8">
            {/* Bank Transfer */}
            <div className="bg-white rounded-lg p-6 shadow-xl">
              <h2 className="text-2xl font-bold text-blue-400 mb-4">Bank Transfer</h2>
              <div className="space-y-4">
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">Account Name:</span>
                  <div className="flex items-center space-x-2">
                    <span className="font-semibold">{bankDetails.accountName}</span>
                    <button
                      onClick={() => copyToClipboard(bankDetails.accountName, 'accountName')}
                      className="p-1 hover:bg-gray-100 rounded"
                      title="Copy to clipboard"
                    >
                      <FaCopy className={copied.accountName ? "text-green-500" : "text-gray-400"} />
                    </button>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">Account Number:</span>
                  <div className="flex items-center space-x-2">
                    <span className="font-semibold">{bankDetails.accountNumber}</span>
                    <button
                      onClick={() => copyToClipboard(bankDetails.accountNumber, 'accountNumber')}
                      className="p-1 hover:bg-gray-100 rounded"
                      title="Copy to clipboard"
                    >
                      <FaCopy className={copied.accountNumber ? "text-green-500" : "text-gray-400"} />
                    </button>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">IFSC Code:</span>
                  <div className="flex items-center space-x-2">
                    <span className="font-semibold">{bankDetails.ifscCode}</span>
                    <button
                      onClick={() => copyToClipboard(bankDetails.ifscCode, 'ifscCode')}
                      className="p-1 hover:bg-gray-100 rounded"
                      title="Copy to clipboard"
                    >
                      <FaCopy className={copied.ifscCode ? "text-green-500" : "text-gray-400"} />
                    </button>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">Account Type:</span>
                  <div className="flex items-center space-x-2">
                    <span className="font-semibold">{bankDetails.accountType}</span>
                    <button
                      onClick={() => copyToClipboard(bankDetails.accountType, 'accountType')}
                      className="p-1 hover:bg-gray-100 rounded"
                      title="Copy to clipboard"
                    >
                      <FaCopy className={copied.accountType ? "text-green-500" : "text-gray-400"} />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* UPI Payment */}
            <div className="bg-white rounded-lg p-6 shadow-xl">
              <h2 className="text-2xl font-bold text-blue-400 mb-4">UPI Payment</h2>
              <div className="space-y-4">
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">UPI ID:</span>
                  <div className="flex items-center space-x-2">
                    <span className="font-semibold">{bankDetails.upiId}</span>
                    <button
                      onClick={() => copyToClipboard(bankDetails.upiId, 'upiId')}
                      className="p-1 hover:bg-gray-100 rounded"
                      title="Copy to clipboard"
                    >
                      <FaCopy className={copied.upiId ? "text-green-500" : "text-gray-400"} />
                    </button>
                  </div>
                </div>
                <div className="text-center mt-4">
                  <div className="bg-white p-4 rounded-lg shadow-md inline-block">
                    <img 
                      src={upiDetails.qrCode} 
                      alt="UPI QR Code" 
                      className="w-48 h-48"
                    />
                  </div>
                  <p className="text-sm text-gray-500 mt-2">Scan QR code to pay</p>
                  <button
                    onClick={downloadQRCode}
                    className="mt-4 flex items-center space-x-2 bg-blue-400 text-white px-4 py-2 rounded-lg hover:bg-blue-500 transition-colors duration-300 mx-auto"
                  >
                    <FaDownload />
                    <span>Download QR Code</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Company Details and Tax Benefits */}
          <div className="space-y-8">
            {/* Company Details */}
            <div className="bg-white rounded-lg p-6 shadow-xl">
              <h2 className="text-2xl font-bold text-blue-400 mb-4 text-left">Company Details</h2>
              <div className="space-y-4">
                <div className="flex items-start">
                  <FaBuilding className="text-blue-400 text-xl mt-1 mr-3" />
                  <div className="text-left">
                    <h3 className="font-semibold text-left">Company Name</h3>
                    <p className="text-gray-600 text-left">VALARCCI FOUNDATION</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <FaPhone className="text-blue-400 text-xl mt-1 mr-3" />
                  <div className="text-left">
                    <h3 className="font-semibold text-left">Phone</h3>
                    <p className="text-gray-600 text-left">+91 8053232672</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <FaEnvelope className="text-blue-400 text-xl mt-1 mr-3" />
                  <div className="text-left">
                    <h3 className="font-semibold text-left">Email</h3>
                    <p className="text-gray-600 text-left">director@valarccifoundation.co.in</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <FaMapMarkerAlt className="text-blue-400 text-xl mt-1 mr-3" />
                  <div className="text-left">
                    <h3 className="font-semibold text-left">Address</h3>
                    <p className="text-gray-600 text-left">Vpo. Bandaheri, Hisar, Haryana 125001</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <FaGlobe className="text-blue-400 text-xl mt-1 mr-3" />
                  <div className="text-left">
                    <h3 className="font-semibold text-left">Website</h3>
                    <p className="text-gray-600 text-left">valarccifoundation.co.in</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Tax Benefits */}
            <div className="bg-white rounded-lg p-6 shadow-xl">
              <h2 className="text-2xl font-bold text-blue-400 mb-4">Tax Benefits</h2>
              <div className="space-y-4">
                <p className="text-gray-600">
                  Your donations to VALARCCI FOUNDATION are eligible for tax benefits under Section 80G of the Income Tax Act, 1961.
                </p>
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-blue-400 mb-2">Important Information</h3>
                  <ul className="list-disc list-inside text-gray-600 space-y-2">
                    <li>Donations are eligible for 50% tax deduction</li>
                    <li>No minimum or maximum limit on donation amount</li>
                    <li>Tax receipt will be provided for all donations</li>
                    <li>Valid for both individual and corporate donors</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Information */}
        <div className="mt-12 bg-white rounded-lg p-6 shadow-xl">
          <h2 className="text-2xl font-bold text-blue-400 mb-4">How Your Donation Helps</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center p-4">
              <div className="text-4xl font-bold text-blue-400 mb-2">₹1000</div>
              <p className="text-gray-600">Provides blood testing for 5 patients</p>
            </div>
            <div className="text-center p-4">
              <div className="text-4xl font-bold text-blue-400 mb-2">₹5000</div>
              <p className="text-gray-600">Supports one blood donation camp</p>
            </div>
            <div className="text-center p-4">
              <div className="text-4xl font-bold text-blue-400 mb-2">₹10000</div>
              <p className="text-gray-600">Helps 20 patients with blood transfusions</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DonationPage; 